import WebRoutes from './Web'
import PanelRoutes from './Panel'
// ** Document title
const TemplateTitle = '%s - Admin Panel'

// ** Default Route
const LoginRoute = '/login';
const DefaultRoute = '/';

// ** Merge Routes
const Routes = {
    web: WebRoutes,
    panel: PanelRoutes
}

export {LoginRoute, DefaultRoute, TemplateTitle, Routes}
